module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_4_3.72db02f2.png";